import { FunnelChart, Funnel, LabelList, ResponsiveContainer, Tooltip } from 'recharts';
import { Card } from '@/components/ui/card';

interface PyramidChartProps {
  title: string;
  data: Array<{
    stage: string;
    count: number;
  }>;
  // Shown instead of the chart when there is nothing to draw.
  emptyText?: string;
}

// The lead funnel. Each stage's share is of the FIRST stage, so it reads as "how many of all my
// contacts got this far".
export default function PyramidChart({ title, data, emptyText }: PyramidChartProps) {
  const top = data[0]?.count || 0;
  const rows = data.map((d, i) => ({
    ...d,
    label: `${d.stage} · ${d.count.toLocaleString()}${top > 0 && i > 0 ? ` (${Math.round((d.count / top) * 100)}%)` : ''}`,
    // One hue, fading stage by stage, so the funnel reads as one quantity narrowing.
    fill: 'hsl(var(--primary))',
    fillOpacity: Math.max(0.25, 1 - i * 0.14),
  }));

  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-6">{title}</h3>
      {top === 0 && emptyText ? (
        <p className="py-12 text-center text-sm text-muted-foreground">{emptyText}</p>
      ) : (
        <ResponsiveContainer width="100%" height={400}>
          <FunnelChart>
            <Tooltip formatter={(value: number) => value.toLocaleString()} />
            <Funnel dataKey="count" nameKey="stage" data={rows} isAnimationActive>
              {/* `fill-foreground` rather than a fixed colour: black labels vanished in dark mode. */}
              <LabelList position="right" dataKey="label" stroke="none" className="fill-foreground text-sm" />
            </Funnel>
          </FunnelChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
}
